import React from "react";
import EvalProvider from "./EvalContext";
import ImageViewer from "./imageViewer";
import { FullScreen, useFullScreenHandle } from "react-full-screen";

export default (props) => {
  return (
    <EvalProvider>
      <ImageViewer {...props} />
    </EvalProvider>
  );
};
